import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UserCreate from '@app/views/User/Create';
import { memo } from 'react';

export default memo(
  withIfUser(UserCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
